import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import AdminNav from "../AdminNav";
import config from "../../../../function/config";
import Footer from "../../../Footer";
import NewAdminNav from "../NewAdminNav";
import NewFooter from "../../../NewFooter";

export default function AdminTug() {
  const [isScrolled, setIsScrolled] = useState(false);
      const [Type, setType] = useState("grid");
      const [count,setCount] = useState(0)
      const [input, setInput] = useState("");
      const [filteredShips, setFilteredShips] = useState([]);
      useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
        };
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
    

      const [allImagesReg,setAllImagesReg] = useState([])
    
      useEffect(() => {
        async function fetchdata() {
          try {
            const res3 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              }
            );
            if (res3.data.status === 200) {
              console.log("Images :",res3);
              setAllImagesReg(res3.data.data);
            } else {
              console.log("error");
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [config.base_url,input,count]);
      
      // Scroll to the top
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      };
      const [allShips, setAllShips] = useState([]);
      const [allShipsReg, setallShipsReg] = useState([]);

      const [currentPage, setCurrentPage] = useState(1);
      const [refPage, setRefPage] = useState(1);
      const [loading, setLoading] = useState(true);
      const [allImages, setAllImages] = useState([]);
    
      const navigate = useNavigate();
      const location = useLocation();
    
      const combinedShips = [...allShips, ...allShipsReg]
  .filter(ship => ship.created_at) // Ensure created_at exists
  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort by latest


 const filteredCombinedShips = combinedShips.filter(
  (ship) =>
    ship.title &&
    ship.title.toLowerCase().includes(input.toLowerCase())
);
      
      
        // Pagination logic
        const itemsPerPage = 12;
        const searchParams = new URLSearchParams(location.search);
        const pageFromUrl = parseInt(searchParams.get("page")) || 1;
      
        // Filtering logic based on search input
        const filteredGroups = allShips.filter(
  (group) =>
    group.title &&
    group.title.toLowerCase().includes(input.toLowerCase())
);
      
        // Calculate total pages
        const totalPages = Math.ceil((allShips.length + allShipsReg.length) / itemsPerPage);
      
        // Set currentPage based on URL and fetch ships accordingly
        useEffect(() => {
          if (pageFromUrl >= 1 && pageFromUrl <= totalPages) {
            setCurrentPage(pageFromUrl);
            setRefPage(pageFromUrl);
          }
        }, [pageFromUrl, totalPages]);
      
      
        const handleNavigateToSingleShip = (ship) => {
  const route = ship.is_allow
    ? `/adminsingleRegshipforsale/${ship.id}`
    : `/adminSingleShip/${ship.id}`;

  navigate(route, {
    state: {
      prevPage: location.pathname,  // 👈 rename from "from" → "prevPage"
      prevPageNumber: currentPage,  // 👈 rename from "page" → "prevPageNumber"
    },
  });
};
      
      // Handle page change
      const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
          navigate(`/AdminTug?page=${page}`); // Update URL first
          setCurrentPage(page);
          setRefPage(page);
        }
         if (page >= 1 && page <= totalCombinedPages) {
    localStorage.setItem("currentPage", page); // Save page
    window.scrollTo({ top: 50, behavior: 'smooth' }); // Smooth scroll to top

    setTimeout(() => {
    }, 300); // Adjust delay as needed
  }
      };
      useEffect(() => {
  const savedPage = parseInt(localStorage.getItem("currentPage"));
  if (savedPage && savedPage >= 1 && savedPage <= totalCombinedPages) {
    setCurrentPage(savedPage);
  } else {
    setCurrentPage(1); // Default to 1 if nothing saved
  }
}, []);

useEffect(() => {
  const savedPage = parseInt(localStorage.getItem("currentPage"));
  if (savedPage && savedPage >= 1 && savedPage <= totalCombinedPages) {
    setCurrentPage(savedPage);
  } else {
    setCurrentPage(1); // Default to 1 if nothing saved
  }
}, []);
    
      // Paginated data
      const startIndex = (currentPage - 1) * itemsPerPage;
      const paginatedGroups = filteredGroups.slice(
        startIndex,
        startIndex + itemsPerPage
      );

   // Fetch ships
useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          search_items: input,
        },
      });

      if (res1.data.status === 200) {
        console.log(res1);
        
        if (res1.data.data.length < 7) {
          setCurrentPage(1);
        }
        
        if (input === "") {
          setCurrentPage(refPage);
        }

        // Filter ships where vessel_type is "Cargo" and sort by latest created_at
        let sortedShips = res1.data.data
          .filter(ship => ship.vessel_type === "Tug Boat" && ship.created_at) // Ensure it's Cargo and has created_at
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setAllShips(sortedShips.reverse());
      } else {
        console.log("Error fetching ships");
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchData();
}, [config.base_url, input, currentPage, refPage]);

// Fetch ships
useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          search_items: input,
        },
      });

      if (res1.data.status === 200) {
        console.log(res1);
        
        if (res1.data.data.length < 7) {
          setCurrentPage(1);
        }
        if (input === "") {
          setCurrentPage(refPage);
        }

        // Filter ships where vessel_type is "Cargo" and is_allow is true
        let filteredShipsReg = res1.data.data
          .filter(ship => ship.is_allow && ship.vessel_type === "Tug Boat") // Only Cargo ships that are allowed
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort by latest created_at

        setallShipsReg(filteredShipsReg.reverse());
      } else {
        console.log("Error fetching ships");
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();
}, [config.base_url, input, currentPage, refPage]);


 // Fetch images for ships
 useEffect(() => {
  async function fetchImages() {
    try {
      const res3 = await axios.get(`${config.base_url}/api/HappyMarineShipping/ship_images`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res3.data.status === 200) {
        setAllImages(res3.data.data);
      } else {
        console.log("Error fetching images");
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchImages();
}, [config.base_url, input, count]);

// Scroll to top on page change
const { pathname } = useLocation();
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, [pathname]);

// Loading state
useEffect(() => {
  const fetchShips = async () => {
    try {
      setLoading(true); // Start loading
      const response = await fetch("API_ENDPOINT"); // Replace with your API
      const data = await response.json();
      setAllShips(data);
    } catch (error) {
      console.error("Error fetching ships:", error);
    } finally {
      setLoading(false); // Stop loading after fetch
    }
  };

  fetchShips();
}, []);
  

const filteredAllShipsReg = allShipsReg
      .filter((ship) => ship.is_allow)
      .map((ship) => ({ ...ship, isFromReg: true }));

const filteredAdminShips =  allShips;

const allShipsWithFlag = filteredAdminShips.map((ship) => ({
  ...ship,
  isFromReg: false,
}));

const [isSearchTriggered, setIsSearchTriggered] = useState(false);
const [selectedCountry, setSelectedCountry] = useState(null);


/// Merge and sort ships by created_at (latest first)
const dataToPaginate = isSearchTriggered
  ? filteredShips
  : [...allShipsWithFlag, ...filteredAllShipsReg];

const sortedData = dataToPaginate.sort(
  (a, b) => new Date(b.created_at) - new Date(a.created_at)
);
// Pagination Logic for Combined Data
const totalCombinedPages = Math.ceil(sortedData.length / itemsPerPage);
const paginatedShips = sortedData.slice(startIndex, startIndex + itemsPerPage);


const handleChange = (e) => {
    const selectedRoute = e.target.value;
    if (selectedRoute) {
      navigate(selectedRoute);
    }
  };

  const [Class, setClass] = useState('');
  const [vesselType, setVesselType] = useState('Tug Boat');
  const [builtYear, setBuiltYear] = useState('');
  const [capacity, setCapacity] = useState('');
    const [showNoResults, setShowNoResults] = useState(false);
  
      
   
  const vesselSubTypes = {
    Barge: [" Cargo Barge","Tanker Barge", "Accommodation Barge", "Self-Propelled Barge"],
    Bulk: ["Handymax Bulk Carrier","Supramax Bulk Carrier","Ultramax Bulk Carrier","Panamax Bulk Carrier","Kamsarmax Bulk Carrier", "Mini Bulk Carrier","Post-Panamax Bulk Carrier", "Log Carrier", "Cement Carrier"],
    Cargo: ["General Cargo", "Tween Decker"],
    Container: ["Feeder Container Ship","Panamax Container Ship","Post-Panamax Container Ship","New Panamax (Neo-Panamax)","Mega Container carrier","Fully Cellular Container Ship","Container Barge"],
    Fishing: ["Longliner", "Purse Seiner","Shrimp Trawler","Stern Trawler"],
    Multipurpose: ["General Cargo + Container Ship","General Cargo + Bulk Carrier","Container + Ro-Ro Ship (ConRo)","Heavy Lift Multipurpose Vessel","Tweendecker (with multiple cargo decks)",'Livestock'],
    "Passenger/Ferry":["Cruise Ship","High-Speed Craft", "Catamaran Ferry", "Hydrofoil", "Hovercraft", "Day Passenger Vessel", "Water Taxi"],
    Reefer: ["Conventional Reefer Ship","Reefer Container Ship","Side Door Reefer Ship","Palletized Reefer Ship","Fish Reefer Vessel"],
    RoRo:["Pure Car Carrier (PCC)", "Ro-Ro Cargo Ship","Ro-Pax Ship (Ro-Ro + Passenger)","LOLO Cargo Ship","Double-Ended Ro-Ro"],
    Tanker: ["Crude Oil Tanker","Product Tanker","Chemical Tanker","Oil Tanker","LNG Carrier (Liquefied Natural Gas)","LPG Carrier (Liquefied Petroleum Gas)","Bitumen Tanker","Oil Recovery Vessel","Bunker vessel ","Slop Barge Tanker","Water Tanker", "Edible Oil Tanker"],
    Dredger: ["Cutter Suction Dredger","Hopper Dredger","Bucket Dredger","Backhoe Dredger","Grab Dredger"],
    "Floating Crane": ["Sheerleg Crane Vessel","Crane Barge","Jack-Up Crane Vessel","Derrick Barge","Floating Gantry Crane"],
    "Floating Dock": ["Pontoon-Type Floating Dock","Submersible Floating Dock","Ship-Lift Floating Dock","Floating Dry Dock"],
    "Landing Craft": ["Landing Craft Utility (LCU)","Landing Craft tanker"],
    Yacht:["Sailing Yacht","Motor Yacht","Catamaran Yacht","Trimaran Yacht","Superyacht","Megayacht","Flybridge Yacht"],
    "Tug Boat":["Harbor Tug","Ocean Tug","Escort Tug","Azimuth Stern Drive (ASD) Tug","Pusher Tug","Anchor Handling Tug (AHT)"],
    "Supply Boat":["Platform Supply Vessel (PSV)","Anchor Handling Tug Supply (AHTS)","Utility Vessel","Multi-Purpose Support Vessel (MPSV)","Diving Support Vessel (DSV)","Cable Laying Vessel","Accommodation Supply Vessel","DP Supply Boat (Dynamic Positioning)"],
    "Crew Boat": [" Fast Crew Boat","Fast Supply Intervention Vessel (FSIV)"],
    Other: [""]
  };

  
    const [subType, setSubType] = useState("");
    
      const handleVesselTypeChange = (e) => {
        const selectedType = e.target.value;
        setVesselType(selectedType);
        setSubType(""); // Reset subType when vesselType changes
      };
    
    
      const [showTypeError, setShowTypeError] = useState(false);
      const typeRef = useRef(null);
    
    const handleSearch = async () => {
  setLoading(true);
  setIsSearchTriggered(true); // ✅ mark search started

  try {
    const adminShipPromise = axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`, {
      params: {
        vessel_type: vesselType,
        flag: selectedCountry,
        year_built: builtYear,
        sub_type:subType,
        Class:Class
      },
    });

    const regShipPromise = axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
      params: {
        vessel_type: vesselType,
        flag: selectedCountry,
        year_built: builtYear,
        DWT: capacity,
        sub_type:subType,
        Class:Class
      },
    });

    const [adminRes, regRes] = await Promise.all([adminShipPromise, regShipPromise]);

    const adminData = adminRes.data.status === 200 ? adminRes.data.data : [];
    const regDataRaw = regRes.data.status === 200 ? regRes.data.data : [];

    const regData = regDataRaw
      .filter((ship) => ship.is_allow)
      .map((ship) => ({ ...ship, isFromReg: true }));

    const adminDataWithFlag = adminData.map((ship) => ({
      ...ship,
      isFromReg: false,
    }));

    const combined = [...adminDataWithFlag, ...regData];
    const sorted = combined.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    setFilteredShips(sorted);
    setCurrentPage(1);
    setShowNoResults(sorted.length === 0);
  } catch (error) {
    console.log("Search error:", error);
    setFilteredShips([]);
    setShowNoResults(true);
  } finally {
    setLoading(false);
  }
};

const clearFilters = async () => {
  setVesselType("Tug Boat");
  setSubType("");
  setSelectedCountry("");
  setBuiltYear("");
  setCapacity("");
  setCurrentPage(1);
  setShowNoResults(false);
  setClass("")
  setLoading(true);

  try {
    // Fetch all ships without any filters
    const [adminRes, regRes] = await Promise.all([
      axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`),
      axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`),
    ]);

    const adminData = adminRes.data.status === 200 ? adminRes.data.data.filter(ship => ship.is_allow && ship.vessel_type === "Tug Boat") : [];
    const regDataRaw = regRes.data.status === 200 ? regRes.data.data.filter(ship => ship.is_allow && ship.vessel_type === "Tug Boat") : [];

    const regData = regDataRaw
      .filter((ship) => ship.is_allow)
      .map((ship) => ({ ...ship, isFromReg: true }));

    const adminDataWithFlag = adminData.map((ship) => ({
      ...ship,
      isFromReg: false,
    }));

    const combined = [...adminDataWithFlag, ...regData];
    const sorted = combined.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    setFilteredShips(sorted);
  } catch (error) {
    console.error("Error fetching ships:", error);
    setFilteredShips([]);
    setShowNoResults(true);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="">
      <NewAdminNav />

      <section className="py-5 bg-[#9ccee2] ">
        {/* <h1 className="text-white text-center text-2xl font-bold">Tug Boat Vessel For Sale</h1> */}

         <div className=" rounded py-5 px-10 Lg:py-5  m-auto">
           
          {/* buttons for grid or list and search input */}
           <div className="flex   py-3  m-auto rounded-full w-[90%] justify-center items-center  gap-5  flex-wrap">
       {/* <h1 className="font-semibold text-xl mt-2 xm:hidden">Looking For</h1> */}
         {/* <i className="fa-solid 3xl:hidden text-4xl text-[#d1a460] fa-circle-chevron-right"></i> */}
         {/* Type of ship */}
          {/* Vessel Type */}
<div className="w-[200px] xm:w-[100%] space-y-3">
  <select
    ref={typeRef}
    value={vesselType}
    onChange={(e) => {
      handleVesselTypeChange(e);
      setShowTypeError(false); // clear red when fixed
    }}
    className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea appearance-none outline-none border-2"
    // Inline style ensures it wins over your .capsule-openarea border
    style={showTypeError ? { borderColor: "#ef4444", borderWidth:'2px',color:'red' } : { borderColor: "#e5e7eb" }} // #e5e7eb ≈ border-gray-300
    name="vesselType"
    id="VesselType"
  >
    {showTypeError?(<option className="text-red-500" hidden value="">
      please Select Ship Type First
    </option>):(<option hidden value="">
      - Type of Ships -
    </option>)}
    <option disabled className="text-gray-500 font-semibold" value="">
      Categories
    </option>
    
    <option className="text-gray-500" value=""> All Types</option>
    {Object.keys(vesselSubTypes).map((type) => (
      <option key={type} value={type} className="text-gray-500">
        {type}
      </option>
    ))}
  </select>
</div>

{/* Sub Type */}
<div className="w-[200px] xm:w-full space-y-3">
  <select
    value={subType}
    onMouseDown={(e) => {
      // Fires even if value doesn't change; catches "direct click"
      if (!vesselType) {
        e.preventDefault();         // stop opening dropdown
        setShowTypeError(true);     // turn type select red
        typeRef.current?.focus();   // move focus to Type of Ship
      }
    }}
    onChange={(e) => {
      // Safety: if they somehow bypass onMouseDown (keyboard), still guard
      if (!vesselType) {
        setShowTypeError(true);
        typeRef.current?.focus();
        return;
      }
      setSubType(e.target.value);
    }}
    className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea appearance-none outline-none border border-gray-300"
    name="subType"
  >
    {vesselType ? (
      <>
        <option hidden value="">
          - Select Subtype -
        </option>
        {vesselSubTypes[vesselType].map((sub) => (
          <option key={sub} value={sub}>
            {sub}
          </option>
        ))}
      </>
    ) : (
      <>
        <option hidden value="">
          - Select Subtype -
        </option>
        <option value="" disabled>
          Please select Ship Type first
        </option>
      </>
    )}
  </select>
</div>

  
              {/* Built Year */}
          <div className="w-[200px] xm:w-[100%]">
            <select
            value={builtYear}
             onChange={(e) => setBuiltYear(e.target.value)}
              className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
              name="builtYear"
              id="builtYear"
            >
              <option disabled selected value="">
                - Built Year -
              </option>
              <option className="text-gray-500" value=""> All Year</option>
              <option value="1990-1995" className="text-gray-500">
                1990 - 1995
              </option>
              <option value="1996-2000" className="text-gray-500">
                1996 - 2000
              </option>
              <option value="2001-2005" className="text-gray-500">
                2001 - 2005
              </option>
              <option value="2006-2010" className="text-gray-500">
                2006 - 2010
              </option>
              <option value="2011-2015" className="text-gray-500">
                2011 - 2015
              </option>
              <option value="2016-2020" className="text-gray-500">
                2016 - 2020
              </option>
              <option value="2021-2025" className="text-gray-500">
                2021 - 2025
              </option>
            </select>
          </div>

           {/* Class */}
           <div className="w-[200px] xm:w-[100%]">
            <select
  value={Class}
  onChange={(e) => setClass(e.target.value)}
  className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
  name="Class"
  id="Class"
>
  <option disabled selected value="">
    - Classification -
  </option>
  <option className="text-gray-500" value=""> All Class</option>
  <option value="BV" className="text-gray-500">BV</option>
  <option value="RINA" className="text-gray-500">RINA</option>
  <option value="CCS" className="text-gray-500">CCS</option>
  <option value="CC" className="text-gray-500">CC</option>
  <option value="ZC" className="text-gray-500">ZC</option>
  <option value="CSA" className="text-gray-500">CSA</option>
  <option value="NK" className="text-gray-500">NK</option>
  <option value="NKK" className="text-gray-500">NKK</option>
  <option value="DNV" className="text-gray-500">DNV</option>
  <option value="KR" className="text-gray-500">KR</option>
  <option value="ABS" className="text-gray-500">ABS</option>
  <option value="Non IACS" className="text-gray-500">Non IACS</option>
</select>
          </div>
          
  
  
          {/* Capacity */}
          <div className="w-[200px]  xm:w-[100%]">
            <select
            value={capacity}
                         onChange={(e) => setCapacity(e.target.value)}
                        className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                        name="Capacity"
                        id="Capacity"
                      >
                        <option hidden selected value="">
                          - Capacity-
                        </option>
                        <option
                          disabled
                          className="text-gray-500 font-semibold"
                          value=""
                        >
                          Catagories
                        </option>
                        <option className="text-gray-500" value=""> All Capacity</option>
                        <option value="1000-5000">1000 - 5000</option>
                        <option value="5000-10000">5000 - 10000</option>
                        <option value="10000-15000">10000 - 15000</option>
                        <option value="15000-25000">15000 - 25000</option>
                        <option value="25000-50000">25000 - 50000</option>
                        <option value="50000-more">50000 - more</option>

                        
                  
                      </select>
          </div>
        
  
         <div className="flex gap-3 items-center ">
    <button
      className="bg-gray-50  px-3 py-[10px] rounded-xl w-full "
      onClick={clearFilters}
    >
      Clear
    </button>
    <button
    onClick={handleSearch}
      className="bg-[#d1a460] text-gray-50 hover:bg-[#c6a067] px-3 py-[10px] rounded-xl w-full "
      
    >
      Search
    </button>
  </div>
      </div>

          {/* section details  */}

          <div className=" flex mt-10 lg:flex-wrap gap-10 items-start">
            
           

            {/* Right: Ship Cards grid type */}
            {Type === "grid" && (
             <>
             {/* Left: Types of Ships */}
                   <div className="xm:hidden -mt-4">
                  <h1 className="text-2xl  font-semibold text-[#123557]">
                    Types of Ships
                  </h1>

                  <ul className="text-[#d1a460] xm:hidden mt-3  py-3 w-[250px] xl:w-[100%] lg:w-[700px] md:w-[630px] sm:w-[540px]  ssm:w-[480px] xm:w-[373px] xs:w-[330px]">
                    <li onClick={()=>navigate('/adminshipforsale')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                      All Ships
                    </li>
                    <li onClick={()=>navigate('/adminBarge')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                      Barge
                    </li>
                    <li onClick={()=>navigate('/adminBulk')}  className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                      Bulk
                    </li>
                    <li onClick={()=>navigate('/admincargo')}  className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                      Cargo
                    </li>
                    <li onClick={()=>navigate('/adminContainer')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                      Container
                    </li>
                    <li onClick={()=>navigate('/adminFishing')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Fishing
                    </li>
                    <li onClick={()=>navigate('/adminMultipurpose')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Multipurpose
                    </li>
                    <li onClick={()=>navigate('/adminPassengerFerry')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Passenger/Ferry
                    </li>
                    <li onClick={()=>navigate('/adminReefer')}className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Reefer
                    </li>
                    <li onClick={()=>navigate('/adminRoro')}className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        RoRo
                    </li>
                    <li onClick={()=>navigate('/adminTanker')}className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Tanker
                    </li>
                    <li onClick={()=>navigate('/adminDredger')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Dredger
                    </li>
                    <li onClick={()=>navigate('/adminFloating-Crane')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Floating Crane
                    </li>
                    <li onClick={()=>navigate('/adminFloating-Dock')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Floating Dock
                    </li>

                    <li onClick={()=>navigate('/adminLanding-Craft')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                      Landing Craft
                    </li>
                    <li onClick={()=>navigate('/adminYacht')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Yacht
                    </li>
                    <li onClick={()=>navigate('/adminTug')} className="border mt-3 bg-[#123557] border-[#123557] rounded-lg px-3  py-3 text-[16px] text-white  cursor-pointer ">
                        Tug Boat
                    </li>
                    <li onClick={()=>navigate('/adminSupplyBoat')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Supply Boat
                    </li>
                    <li onClick={()=>navigate('/adminCrewBoat')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Crew Boat
                    </li>
                    <li onClick={()=>navigate('/adminOthers')} className="border mt-3  border-[#123557] rounded-lg px-3  py-3 text-[16px] text-[#123557] cursor-pointer hover:bg-[#123557] hover:text-white transition-all duration-300">
                        Others
                    </li>
                  </ul>
                </div>
                <div className=" flex  flex-wrap justify-center mx-auto flex-col items-center">
                  {/* Card Grid */}
                  <div
                    className="grid L:grid-cols-2 grid-cols-3 gap-12 justify-center sm:grid-cols-2 xm:grid-cols-1 mt-10"
                    style={{ minHeight: "800px" }} // Set a consistent minimum height for the grid
                  >
                    {paginatedShips.length === 0 ? (
                      <div className="col-span-full text-center">
                        <p className="text-xl mt-16 text-red-600">
                          {" "}
                          Tug Boat Ships not Available...
                        </p>
                      </div>
                    ) : (
                      paginatedShips.map((card, index) => (
                        <div
                          key={index}
                          onClick={() => handleNavigateToSingleShip(card)}
                          className="w-[370px] 3xl:w-[290px] xl:w-[260px] overflow-hidden lg:w-[100%] h-[300px] hover:scale-105 duration-300 bg-gray-100 transition-all rounded-lg border border-white cursor-pointer relative"
                        >
                         <div className="m-auto rounded-lg">
  {card.isFromReg ? (
    (() => {
      const regImg = allImagesReg.find((img) => img.ships === card.id);
      return regImg ? (
        <img
         
          src={regImg.image}
          alt="Customer Ship Image"
          className="w-full h-[150px] "
        />
      ) : null;
    })()
  ) : (
    (() => {
      const saleImg = allImages.find(
        (img) => img.ship === card.id
      );
      return saleImg ? (
        <img
          
          src={saleImg.image}
          alt="Admin Ship Thumbnail"
          className="w-full h-[150px] "
        />
      ) : null;
    })()
  )}
</div>


                          <div className="px-2 py-3 mt-2">
                            <h1 className="font-bold">{card.short_description}</h1>
                            <h1 className="mt-2">{card.year}</h1>
                          </div>
                          <div className="px-2 md:px-1 py-3 w-full flex justify-between absolute bottom-0">
                                    <button
              onClick={() => handleNavigateToSingleShip(card)}
              className="bg-[#d59d49] ml-auto text-white rounded-md px-3 py-2 shadow-lg hover:shadow-xl transition"
              
            >
              More Informations
            </button>
                                    </div>
                        </div>
                      ))
                    )}
  
                    {/* Add placeholder cards if items are fewer */}
                    {paginatedGroups.length > 0 &&
                      paginatedGroups.length < 9 && // Adjust based on max items per page
                      Array.from({ length: 9 - paginatedGroups.length }).map(
                        (_, index) => (
                          <div
                            key={`placeholder-${index}`}
                            className="w-[270px]  md:w-[100%] bg-transparent"
                          />
                        )
                      )}
                  </div>
  
                 {/* Pagination */}
{paginatedShips.length > 0 && (
  <div className="xm:mt-8 mt-10 flex justify-center items-center gap-2">
    {/* Previous Button */}
    <button
      onClick={() => {
        if (currentPage > 1) {
          handlePageChange(currentPage - 1);
        }
      }}
      disabled={currentPage === 1}
      className={`px-3 py-2 bg-[#123d5f] text-white rounded-sm ${
        currentPage === 1
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-[#172f41ed]"
      }`}
    >
      <i className="fa-solid fa-chevron-left"></i>
    </button>

    {/* Page Numbers */}
    {(() => {
      const totalPages = totalCombinedPages;
      const maxPagesToShow = 7;

      // Figure out which "block" of pages we're in
      const blockIndex = Math.floor((currentPage - 1) / maxPagesToShow);
      const startPage = blockIndex * maxPagesToShow + 1;
      const endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, index) => startPage + index
      ).map((page) => (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className={`px-3 py-2 rounded-sm ${
            currentPage === page
              ? "bg-[#d1a460] text-white"
              : "bg-gray-200 hover:bg-gray-300"
          }`}
        >
          {page}
        </button>
      ));
    })()}

    {/* Next Button */}
    <button
      onClick={() => {
        if (currentPage < totalCombinedPages) {
          handlePageChange(currentPage + 1);
        }
      }}
      disabled={currentPage === totalCombinedPages}
      className={`px-3 py-2 bg-[#0d2c45] text-white rounded-sm ${
        currentPage === totalCombinedPages
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-[#172f41ed]"
      }`}
    >
      <i className="fa-solid fa-chevron-right"></i>
    </button>
  </div>
)}

  
                  {/* Right side table list */}
                </div>
             </>
            )}
            {Type === "list" && (
              <>
               <div>
              <h1 className="text-2xl font-semibold text-white">
                Types of Ships
              </h1>

              <ul className="text-[#d1a460] mt-3 py-3 w-[300px] xl:w-[100%] lg:w-[700px] md:w-[630px] sm:w-[540px]  ssm:w-[480px] xm:w-[330px] ">
                <li className="border-b border-white py-1 text-[16px]  font-bold cursor-pointer hover:text-white">
                  <Link
                    to="/shipforsale/list"
                    className="text-inherit hover:no-underline"
                  >
                    All Ships
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[18px] text-white cursor-pointer hover:text-white">
                  <Link to="/Barge/list" className="text-inherit hover:no-underline">
                    Barge
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Bulk/list" className="text-inherit hover:no-underline">
                    Bulk
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/cargo/list" className="text-inherit hover:no-underline">
                    Cargo
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Container/list" className="text-inherit hover:no-underline">
                    Container
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Fishing/list" className="text-inherit hover:no-underline">
                    Fishing
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Multipurpose/list" className="text-inherit hover:no-underline">
                    Multipurpose
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/PassengerFerry/list" className="text-inherit hover:no-underline">
                    Passenger/Ferry
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Reefer/list " className="text-inherit hover:no-underline">
                    Reefer
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Roro/list" className="text-inherit hover:no-underline">
                    Roro
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Tanker/list" className="text-inherit hover:no-underline">
                    Tanker
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Tug/list" className="text-inherit hover:no-underline">
                    Tug
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Dredger/list" className="text-inherit hover:no-underline">
                    Dredger
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Floating-Crane/list" className="text-inherit hover:no-underline">
                    Floating Crane
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Landing-Craft/list" className="text-inherit hover:no-underline">
                    Landing Craft
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Yacht/list" className="text-inherit hover:no-underline">
                    Yacht
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/SupplyBoat/list" className="text-inherit hover:no-underline">
                    Supply Boat
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/CrewBoat/list" className="text-inherit hover:no-underline">
                    Crew Boat
                  </Link>
                </li>
                <li className="border-b border-white py-1 text-[16px] cursor-pointer hover:text-white">
                  <Link to="/Others/list" className="text-inherit hover:no-underline">
                    Others
                  </Link>
                </li>
              </ul>
            </div>
            <div style={{ minHeight: "800px" }} className="flex overflow-x-auto flex-col m-auto gap-10">
                  <div className="">
                    <table className="2xl:w-[900px] w-full  border border-white">
                      <thead className="bg-[#d1a460] ">
                        <tr>
                          <th className="text-white   border-r border-white w-[200px] py-4">
                            Ship Title
                          </th>
                          <th className="text-white   border-r border-white w-[300px] py-4">
                            Ship Image
                          </th>
                          <th className="text-white   border-r border-white  w-[200px] py-4">
                            Vessel Type
                          </th>
                          <th className="text-white   border-r border-white w-[200px] py-4">
                            Flag
                          </th>
                          <th className="text-white   border-r border-white w-[200px] py-4">
                            Short Description
                          </th>
                          <th className="text-white   border-r border-white w-[140px] py-4">
                            Built Year
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedGroups.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center py-4">
                              No Ships Available
                            </td>
                          </tr>
                        ) : (
                          paginatedGroups.map((ship, index) => (
                            <tr key={index} className="border-b">
                              <td onClick={() => handleNavigateToSingleShip(ship.id)} className="px-4 py-2 text-[#d1a460] cursor-pointer hover:underline  text-center  border-r border-white">
                                {ship.title}
                              </td>
                              <td className="px-4 py-2 text-white border-r border-white">
                                <img
                                onClick={() => handleNavigateToSingleShip(ship.id)}
                                src={
                                  allImages.find(
                                    (img) =>
                                      img.ship === ship.id &&
                                      img.thumbnail_image
                                  )?.thumbnail_image || "fallback-image-url"
                                }
                                  alt={ship.title}
                                  text-center
                                  className="w-full cursor-pointer h-[110px]  rounded-md"
                                />
                              </td>
                              <td className="px-4 py-2 text-white border-r  text-center border-white">
                                {ship.vessel_type || "None"}
                              </td>
                              <td className="px-4 py-2 text-white border-r  text-center border-white">
                                {ship.flag || "None"}
                              </td>
                              <td className="px-4 py-2 text-white border-r text-center border-white">
                                {ship.short_description || "None"}
                              </td>
                              <td className="px-4 py-2 text-white border-r text-center border-white">
                                {ship.year_built || "None"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
  
                  {/* pagination */}
             <div className=" py-5 flex justify-center gap-3 ">
                      <button
                        onClick={() => {
                          handlePageChange(currentPage - 1);
                        }}
                        className="px-3 py-1 bg-[#123d5f] hover:bg-[#172f41ed] text-white rounded-sm"
                        disabled={currentPage === 1}
                      >
                        <i class="fa-solid fa-chevron-left"></i>
                      </button>
    
                      <span className="px-3 py-1 bg-[#d1a460] text-white rounded-sm">
                        {currentPage}
                      </span>
    
                      <button
                        onClick={() => {
                          handlePageChange(currentPage + 1);
                        }}
                        className="px-3 py-1 bg-[#0d2c45] hover:bg-[#172f41ed] text-white rounded-sm"
                        disabled={currentPage === totalPages}
                      >
                        <i class="fa-solid fa-chevron-right"></i>
                      </button>
                    </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Go to Top Button */}
      {isScrolled && (
        <div
          className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
        >
          <div
            className="back-to-top px-4 hover:bg-[#615d91]"
            onClick={scrollToTop}
          >
            <i className="fa-solid fa-arrow-up text-2xl"></i>
          </div>
        </div>
      )}
      <NewFooter />
    </div>
  );
}
